import Page from "./page"

function Document(container, opt = {}) {
  this.container = container
  this.zoom  = opt.zoom || 1
  this.pdfJsDocument = null
  this.pages = []

  this.pdfjs = require("babel-loader!pdfjs-dist/build/pdf");
  const PdfjsWorker = require("worker-loader?esModule=false&filename=[name].js!pdfjs-dist/build/pdf.worker.js");
  if (typeof window !== "undefined" && "Worker" in window) {
    this.pdfjs.GlobalWorkerOptions.workerPort = new PdfjsWorker();
  }

  this.container.classList.add('folia-container')
  window.addEventListener('wheel', this.handleWheel.bind(this), { passive: false })
  window.addEventListener('keydown', this.handleKeyDown.bind(this), { passive: false })
}

Document.prototype.handleKeyDown = function (e) {
  const zoomKeys = ['-', '=', '0']
  if ((e.ctrlKey || e.metaKey) && zoomKeys.includes(e.key)) {
    console.log('ZOOM WITH KEYS', e.key, this.pdfJsDocument)
    if (e.key === '0') {
      // this.container.style.zoom = 1
    } else if (e.key === '-') {
      // this.container.style.zoom = 0.8
    } else if (e.key === '=') {
      // this.container.style.zoom = 1.2
    }
    e.preventDefault()
  }
}
Document.prototype.handleWheel = function (e) {
  if (e.ctrlKey) {
    console.log('ZOOM WITH KEYS', this.appContainer)
    e.preventDefault()
  }
}
Document.prototype.open = async function open(fileURI) {
  this.pdfJsDocument = await this.pdfjs.getDocument(fileURI).promise
  return this
}
Document.prototype.release = async function () {}
Document.prototype.render = async function () {
  const numPages = this.pdfJsDocument._pdfInfo.numPages
  for (let numPage = 1; numPage <= numPages; numPage++) {
    const pdfJsPage = await this.pdfJsDocument.getPage(numPage)

    const scale = window.devicePixelRatio
    const viewport = pdfJsPage.getViewport({
      scale, rotation: 0, offsetX: 0, offsetY: 0, dontFlip: false
    })
    const pageContainer = document.createElement('div')
    pageContainer.className = 'folia-page-container'
    pageContainer.setAttribute('data-page', `${pdfJsPage._pageIndex}`)
    pageContainer.style.width = `${viewport.width / scale * this.zoom}px`
    pageContainer.style.height = `${viewport.height / scale * this.zoom}px`

    const pdfCanvas = document.createElement('canvas')
    pdfCanvas.className = 'folia-page-canvas'
    pdfCanvas.setAttribute('data-type', 'pdf')
    pdfCanvas.width = viewport.width
    pdfCanvas.height = viewport.height

    const annoCanvas = document.createElement('canvas')
    annoCanvas.className = 'folia-page-canvas'
    annoCanvas.setAttribute('data-type', 'annoLayer')
    annoCanvas.width = viewport.width
    annoCanvas.height = viewport.height

    pageContainer.appendChild(pdfCanvas)
    pageContainer.appendChild(annoCanvas)
    this.container.append(pageContainer)

    this.pages[pdfJsPage._pageIndex] = new Page(pdfJsPage, viewport, pageContainer, this.zoom)
  }

}

export default Document